import ClassItem from './ClassItem';
import { ClassItemProps, ClassItemValueProps } from './types';

export type { ClassItemProps, ClassItemValueProps };
export default ClassItem;
